import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requestConfig from 'app/requests/Opportunity.requests'
import {
    OpportunityType,
} from '../opportunities.types'

const useGetOpportunityById = (id: number) => {
    return useRequest<OpportunityType>({
        key: RequestKeys.getOpportunityById,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requestConfig.GetOpportunityById),
        enabled: Boolean(id),
        keepPreviousData: true,
    })
}

export default useGetOpportunityById
